var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    y: 0.800781,
    width: 14.4,
    height: 14.4,
    rx: 7.2,
    fill: "#008060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65206 11.088L4.10646 8.35439C4.03799 8.27973 4 8.1821 4 8.08079C4 7.97949 4.03799 7.88186 4.10646 7.80719L4.62086 7.26079C4.6536 7.22536 4.69331 7.19708 4.7375 7.17774C4.7817 7.1584 4.82942 7.14841 4.87766 7.14841C4.9259 7.14841 4.97362 7.1584 5.01782 7.17774C5.06201 7.19708 5.10173 7.22536 5.13446 7.26079L6.91046 9.17519L10.8641 4.91359C10.8968 4.87803 10.9366 4.84964 10.9808 4.83022C11.0251 4.81081 11.0729 4.80078 11.1213 4.80078C11.1696 4.80078 11.2174 4.81081 11.2617 4.83022C11.306 4.84964 11.3457 4.87803 11.3785 4.91359L11.8929 5.46079C11.9615 5.53524 11.9995 5.63277 11.9995 5.73399C11.9995 5.83522 11.9615 5.93275 11.8929 6.00719L7.16486 11.0872C7.13213 11.1226 7.09241 11.1509 7.04822 11.1702C7.00402 11.1896 6.9563 11.1996 6.90806 11.1996C6.85982 11.1996 6.8121 11.1896 6.7679 11.1702C6.72371 11.1509 6.684 11.1226 6.65126 11.0872",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.aa4b97d3.svg";
export { ForwardRef as ReactComponent };